import React, { useState, useEffect } from "react";
import { Statescontex } from "../context";
import { motion, animate } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faXmark } from "@fortawesome/free-solid-svg-icons";
const Errorx: React.FC = () => {
  const { errorshow, errorMessage, setErrorshow } = Statescontex();
  const [progress, setProgress] = useState(100);
  function onclose() {
    setErrorshow(false);
  }

  useEffect(() => {
    if (errorshow) {
      const timer = setTimeout(() => {
        setErrorshow(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [errorshow]);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => Math.max(prev - 1, 0));
    }, 30);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (errorshow) {
      setProgress(100);
    }
  }, [errorshow]);

  // Handle undefined or malformed errorMessage
  const [severity, message] = errorMessage?.split("_") || ["", ""];

  // Updated colors for better visual appeal
  // const backgroundColor =
  //   severity === "h"
  //     ? "error" // High severity (deep red)
  //     : severity === "l"
  //     ? "success" // Low severity (emerald green)
  //     : "warning"; // Default (amber)

  const backgroundColor =
    severity === "h"
      ? "#D32F2F" // High severity (red)
      : severity === "l"
      ? "#2E7D32" // Low severity (green)
      : "#ED6C02"; // Default (amber)

  return (
    errorshow && (
      <motion.div className="w-full md:w-1/3 lg:w-1/4 xl:w-1/5 py-6 md:py-10 px-3 md:px-5 absolute top-0 z-50 ease-in-out right-0">
        <div
          className={`p-3 md:p-4 rounded-lg shadow-lg bg-black fixed w-[200px] md:w-[280px]`}
        >
          <button
            className="absolute top-2 right-3 text-gray-400 hover:text-white"
            onClick={onclose}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
          <FontAwesomeIcon
            icon={faCheckCircle}
            color={backgroundColor}
            className="text-sm md:text-base"
          />
          <span className="text-sm md:text-base text-white">
            {" "}
            {message || "Bad Request"}
          </span>
          <motion.div
            className="absolute left-0 h-1.5 md:h-2"
            style={{
              borderRadius: 7,
              width: `${progress}%`,
              bottom: 0.5,
              backgroundColor: backgroundColor,
            }}
          />
        </div>
      </motion.div>
    )
  );
};

export default Errorx;
